import { render } from "./Spinner.vue?vue&type=template&id=27ec4430&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=27ec4430&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27ec4430"

export default script